exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ColorSample-e2556208{height:75px;width:75px;display:block;border-radius:4px;margin-bottom:1em;margin-top:1em}form input.urlField-9cee2f67{margin-bottom:1em;margin-top:1em}\n", ""]);

// Exports
exports.locals = {
	"ColorSample": "ColorSample-e2556208",
	"urlField": "urlField-9cee2f67"
};